<template>
  <div>
    <Card
      v-if="user && user.group_names.includes('ESTUDIANTES')"
      class="dashboard-card mb-3"
      :hide_title="hide_title"
    >
      <template v-slot:title>
        <b-icon class="card-header-icon" icon="calendar3"></b-icon>
        {{
          $t("dashboard.dashboardView.finished", {
            entity: $getVisibleNames(
              "evaluations2.evaluation",
              true,
              "Evaluaciones"
            ),
          })
        }}</template
      >
      <template v-slot:content>
        <template v-if="institution && institution.kl_assessment">
          <template
            v-if="
              user.group_names.includes('ESTUDIANTES') &&
              publish_test_student.length > 0
            "
          >
            <b-table-simple
              borderless
              small
              hover
              sticky-header="400px"
              class="border-table"
            >
              <b-thead>
                <b-tr>
                  <b-th class="primary-cell-next-test" style="width: 11%">{{
                    $getVisibleNames(
                      "mesh.egressprofilematter",
                      false,
                      "Asignatura"
                    )
                  }}</b-th>
                  <b-th class="primary-cell-next-test" style="width: 10%">{{
                    $getVisibleNames(
                      "evaluations2.evaluation",
                      false,
                      "Evaluación"
                    )
                  }}</b-th>

                  <b-th class="primary-cell-next-test" style="width: 10%">{{
                    $getVisibleNames("evaluations2.test", false, "Instrumento")
                  }}</b-th>
                  <b-th class="primary-cell-next-test" style="width: 7%">
                    {{ $t("dashboard.dashboardView.teachers") }}
                  </b-th>
                  <!-- <b-th class="primary-cell-next-test" style="width: 7%"
                  >Fecha Inicio</b-th
                >
                <b-th class="primary-cell-next-test" style="width: 7%"
                  >Fecha Término</b-th
                > -->
                </b-tr>
              </b-thead>

              <b-tbody>
                <template v-for="test in publish_test_student">
                  <b-tr :key="test.id">
                    <!-- Nombre de la Evaluacion (Evaluacion) -->
                    <b-td class="secondary-cell-next-test text-left">
                      <div class="mr-0">
                        {{ test.matter_name }}
                      </div>
                    </b-td>
                    <!-- Nombre de la Evaluacion (Evaluacion) -->
                    <b-td class="secondary-cell-next-test text-left">
                      <div class="mr-0">
                        {{ test.evaluation_title }}
                      </div>
                    </b-td>
                    <!-- Nombre de la Evaluacion (Test) -->
                    <b-td class="secondary-cell-next-test text-left">
                      <div
                        class="div-href-test mr-0"
                        @click="
                          redirectToTestStudent(test.evaluation_id, test.id)
                        "
                        v-b-tooltip.v-secondary.bottom.noninteractive="{
                          title: $t('dashboard.dashboardView.goToThe', {
                            entity: $getVisibleNames(
                              'evaluations2.evaluation',
                              false,
                              'Evaluación'
                            ),
                          }),
                          boundary: 'viewport',
                        }"
                      >
                        {{ test.title }}
                      </div>
                    </b-td>
                    <b-td class="secondary-cell-next-test text-left">
                      <div>
                        {{ test.section_professors.join(", ") }}
                      </div>
                    </b-td>
                    <!-- Fecha de Inicio -->
                    <!-- <b-td class="secondary-cell-next-test">
                    <template v-if="test.start_time">
                      {{ test.start_time | FormatToDateTime }}
                    </template>
                    <template v-else> N/A </template>
                  </b-td> -->
                    <!-- Fecha de Termino -->
                    <!-- <b-td class="secondary-cell-next-test">
                    <template v-if="test.end_time">
                      {{ test.end_time | FormatToDateTime }}
                    </template>
                    <template v-else> N/A </template>
                  </b-td> -->
                  </b-tr>
                </template>
              </b-tbody>
            </b-table-simple>
          </template>

          <template
            v-if="
              user.group_names.includes('ESTUDIANTES') &&
              publish_test_student.length == 0
            "
          >
            <div class="text-left">
              {{
                $t("dashboard.dashboardView.noEntity", {
                  entity: $getVisibleNames(
                    "evaluations2.evaluation",
                    true,
                    "Evaluaciones"
                  ),
                })
              }}
            </div>
          </template>
        </template>
        <template v-else>
          <div class="text-left">
            <span>{{ $t("dashboard.dashboardView.moduleNotEnabled") }}</span>
          </div>
        </template>
      </template>
    </Card>
  </div>
</template>

<script>
// import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "PublishTestStudent",
  components: {
    Card: () => import("@/components/users/Card"),
  },
  props: {
    hide_title: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      publish_test_student: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
    }),
  },
  methods: {
    redirectToTestStudent(evaluation_id, instrument_id = null) {
      this.$router.push({
        name: "EvaluateeView",
        params: {
          evaluation_id: evaluation_id,
          instrument_id: instrument_id,
        },
      });
    },
    getPublishtTestStudent() {
      if (
        this.user &&
        this.user.group_names.includes("ESTUDIANTES") &&
        this.publish_test_student.length == 0 &&
        this.institution &&
        this.institution.kl_assessment
      ) {
        this.$restful
          .Get(
            `evaluations2/dashboard_student_next_tests/?want_finished_tests=${true}`
          )
          .then((response) => {
            this.publish_test_student = response;
            this.$emit("count", response.length);
          });
      }
    },
  },
  mounted() {
    this.getPublishtTestStudent();
  },
  watch: {
    user() {
      this.getPublishtTestStudent();
    },
    institution() {
      this.getPublishtTestStudent();
    },
  },
  created() {},
};
</script>

<style scoped>
.dashboard-card {
  display: block;
  margin: 0;
}
.dashboard-card >>> .card-container {
  background: var(--kl-surface);
  border: 1px solid var(--kl-border-soft);
  border-radius: var(--kl-card-radius);
  box-shadow: 0 2px 4px rgba(16, 38, 73, 0.06);
  overflow: hidden;
}
.dashboard-card >>> .card-body {
  background: var(--kl-surface) !important;
  padding: 16px;
}
.card-header-icon {
  margin-right: 0.35em;
}
.border-table {
  border-radius: var(--kl-radius-lg);
  border: 1px solid var(--kl-border);
  max-height: calc(100vh - 290px) !important;
  overflow-y: auto;
}
.border-table >>> table {
  margin-bottom: 0;
}
.border-table >>> tbody tr:nth-child(even) > td {
  background-color: var(--kl-surface-muted);
}
.border-table >>> tbody tr:hover > td {
  background-color: var(--kl-surface-hover);
}
.primary-cell-next-test {
  text-align: left;
  vertical-align: middle;
  background: var(--kl-color-accent-soft) !important;
  color: var(--kl-color-primary) !important;
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-caption);
  text-transform: uppercase;
  letter-spacing: var(--kl-ls-wide);
  padding: 11px 12px !important;
  border-bottom: none !important;
  white-space: nowrap;
}
.secondary-cell-next-test {
  text-align: center;
  vertical-align: middle;
  color: var(--kl-text-body);
  font-size: var(--kl-fs-body);
  padding: 11px 12px !important;
  border-bottom: 1px solid var(--kl-border-soft) !important;
}
.div-href-test {
  color: var(--kl-color-primary);
  font-weight: var(--kl-fw-semibold);
  transition: color 0.2s ease;
}
.div-href-test:hover {
  color: var(--kl-color-primary-deep) !important;
  text-decoration: underline;
  cursor: pointer;
}
@media print {
  .secondary-cell-next-test {
    background-color: transparent !important;
  }
}
</style>